import React, { useState } from 'react';
import MeterSizeSection from '../panelDetailSections/MeterSizeSection';
import MeterGridSection from '../panelDetailSections/MeterGridSection';
import FrameSection from '../panelDetailSections/FrameSection';
import BusbarSection from '../panelDetailSections/BusbarSection';
import DistributionSection from '../panelDetailSections/DistributionSection';
import DimensionSection from '../panelDetailSections/DimensionSection';
import ViewModeSection from '../panelDetailSections/ViewModeSection';

const SECTIONS = [
  { id: 'meterSize', label: 'Sayac Boyutlari', component: MeterSizeSection },
  { id: 'meterGrid', label: 'Sayac Bolmesi Ayarlari', component: MeterGridSection },
  { id: 'frame', label: 'Cerceve ve Genel Boyutlar', component: FrameSection },
  { id: 'busbar', label: 'Bara Bolmesi Ayarlari', component: BusbarSection },
  { id: 'distribution', label: 'Dagitim Bolmesi Ayarlari', component: DistributionSection },
  { id: 'dimension', label: 'Olculendirme Ayarlari', component: DimensionSection },
  { id: 'viewMode', label: 'Gorunum Modlari', component: ViewModeSection },
];

export default function PanelDetailTab() {
  const [openSections, setOpenSections] = useState(
    SECTIONS.reduce((acc, s) => ({ ...acc, [s.id]: true }), {})
  );

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({ ...prev, [sectionId]: !prev[sectionId] }));
  };

  return (
    <div className="panel-detail-tab">
      {SECTIONS.map(({ id, label, component: Component }) => (
        <div key={id} className="detail-accordion">
          <button
            className="detail-accordion-header"
            onClick={() => toggleSection(id)}
          >
            <span className="detail-accordion-arrow">
              {openSections[id] ? '\u25BC' : '\u25B6'}
            </span>
            {label}
          </button>
          {openSections[id] && <Component />}
        </div>
      ))}
    </div>
  );
}
